
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/illustrations/[slug]",
      function () {
        return require("private-next-pages/illustrations/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/illustrations/[slug]"])
      });
    }
  